import gql from 'graphql-tag';

export class RecipientQueries {
  static recipientsQuery = gql`
    query DocumentRecipients($documentId: String!) {
      document(documentId: $documentId) {
        id
        recipients {
          firstName
          lastName
          fullName
          companyName
          companyNumber
          title
          mobile
          email
          thumbUrl
          gender
          role
          roleName
          id
          orderNum
          verifyQna
          verifyQnaOpen
          verifyQnaSign
          verifyQnaQuestion
          verifyQnaAnswer
          verifySms
          verifySmsOpen
          verifySmsSign
          verifyLinkedin
          verifyEid
          verifyEidType
          createdAt
          phone
          note
        }
      }
    }
  `;

  static recipientSigningPageURLs = gql`
    query RecipientSigningPageURLs($documentId: String!) {
      recipientSigningPageUrls(documentId: $documentId) {
        recipientId
        url
      }
    }
  `;
}
